export const videoGallery2023Gql = `... on landingPageContent2023_videoGallery_BlockType {
  typeHandle
  pageTitle
  displayInHeaderQuicklinks
  id
  videos {
    ... on videos_Asset {
      videoId
      videoSource
      videoType
      videoDescription
      videoGalleryTranscript
      videoDuration
      galleryEnlarged {
        srcWebp
        srcset
      }
      galleryThumbnail {
        srcWebp
        srcset
      }
    }
  }
}`;
